export function update_topics(topics) {
    return {
        type: "update_topics",
        payload: topics
    }
}
